import { useEffect, useState } from "react";
import { X } from "lucide-react";

export function WhatsappWidget() {
  const [open, setOpen] = useState(false);
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 600);
    return () => clearTimeout(t);
  }, []);

  const phone = "393407487310";
  const text = encodeURIComponent("Ciao! Vorrei informazioni sulla bottega.");
  const href = `https://wa.me/${phone}?text=${text}`;

  return (
    <div className="fixed bottom-5 right-5 z-[60] flex flex-col items-end gap-3">
      {open && (
        <div className="w-[260px] bg-white rounded-2xl shadow-2xl border border-brand-charcoal/10 overflow-hidden animate-in fade-in slide-in-from-bottom-2 duration-200">
          <div className="bg-[#075E54] text-white px-4 py-3 flex items-center justify-between">
            <div>
              <div className="text-sm font-semibold">La Bottega delle Carni</div>
              <div className="text-[11px] opacity-80">Risponde di solito subito</div>
            </div>
            <button onClick={() => setOpen(false)} aria-label="Chiudi" className="opacity-80 hover:opacity-100">
              <X size={16} />
            </button>
          </div>
          <div className="p-4 bg-[#ECE5DD] text-[13px] text-brand-charcoal">
            <div className="bg-white rounded-lg px-3 py-2 shadow-sm">
              Ciao! 👋 Come possiamo aiutarti?
            </div>
          </div>
          <a
            href={href}
            target="_blank"
            rel="noreferrer"
            className="block bg-[#25D366] hover:bg-[#1ebe5a] text-white text-center py-3 text-sm font-medium uppercase tracking-[0.14em] transition-colors"
          >
            Scrivici su WhatsApp
          </a>
        </div>
      )}
      <button
        onClick={() => setOpen((v) => !v)}
        aria-label="Apri WhatsApp"
        className={`relative w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe5a] text-white shadow-xl flex items-center justify-center transition-all duration-300 ${mounted ? "scale-100 opacity-100" : "scale-0 opacity-0"}`}
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
        <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" className="relative">
          <path d="M17.5 14.4c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.6.1-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.4-2.3-1.4-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6.1-.1.3-.3.4-.5.1-.2.2-.3.2-.5.1-.2 0-.4 0-.5-.1-.1-.6-1.5-.8-2-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.4-.2.3-.9.9-.9 2.2 0 1.3 1 2.6 1.1 2.7.1.2 1.9 2.9 4.6 4 .7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.5-.1 1.7-.7 1.9-1.4.2-.7.2-1.2.2-1.4-.1-.1-.3-.2-.5-.3zM12 2C6.5 2 2 6.5 2 12c0 1.8.5 3.5 1.3 5L2 22l5.2-1.4c1.4.8 3.1 1.2 4.8 1.2 5.5 0 10-4.5 10-10S17.5 2 12 2zm0 18c-1.5 0-3-.4-4.3-1.2l-.3-.2-3.1.8.8-3-.2-.3C4.4 15 4 13.5 4 12c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8z"/>
        </svg>
      </button>
    </div>
  );
}
